import React from 'react';
import { CandidateStoryContent } from '../../types';
import '../../styles.scss';

export interface StructuredStoryProps {
  content: CandidateStoryContent[];
}

const StructuredStory: React.FC<StructuredStoryProps> = ({ content }) => {
  if (!Array.isArray(content)) {
    return null;
  }

  return (
    <div data-testid='candidate-story-text-with-prompt'>
      {content.map(({ prompt, response }) => (
        <div
          key={prompt.title}
          className='candidate-stories-prompt-response-pair'
        >
          <h3 className='candidate-stories-prompt-title'>{prompt.title}</h3>
          <div className='candidate-stories-response-box'>
            <p className='candidate-stories-response-text'>{response}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StructuredStory;
